import React from "react"
import * as sectionStyle from "../section.module.css"
import * as newsStyle from "./news.module.css"
import { StaticImage } from "gatsby-plugin-image"
import { NewsItem } from "./newsItem.js"
const newsList = [
  {
    index: "01",
    date: "2021.05.16",
    title: "ETH HACKATHON 2021! Openness, Freedom and Increment",
    titleZH: "以太坊黑客松活动圆满落幕",
    content:
      "The ETH HACKATHON jointly hosted by the Rebase community, ETHPlanet community, and WhiteMatrix was successfully held both online and offline starting from May 14, 2021. More than 100 developers formed more than 30 teams from all over the country participated in this event, 25 teams successfully completed full-featured and complete demonstrations. Among them, the projects of 5 teams were unanimously approved by the instructor and won the top three in this competition.",
    contentZH: `5月16日下午，由Rebase社区、ETHPlanet社区和纯白矩阵联合主办、以太坊基金会官方支持的以太坊黑客松活动圆满落下帷幕。作为本次大赛的承办方之一，纯白矩阵一直致力于   建设创新性、自由性、开放性的开发者社区生态，大力推广黑客松文化。`,
    link: "https://matrixwhite-mgt.medium.com/ethereum-hackathon-2021-676a8f2625bf",
    linkZH: "https://mp.weixin.qq.com/s/6ymSKVY-LLwwqMzT3qx4WA",
  },
  {
    index: "02",
    date: "2021.04.30",
    title: "WhiteMatrix Conducted Blockchain Multimedia Data Science Seminar",
    titleZH: "纯白矩阵 x 阿尔伯塔大学BMDS2021区块链多媒体数据科学研讨会",
    content:
      "University of Alberta and WhiteMatrix jointly organized the BMDS2021. Famous and well-reputed researcher and practitioners from both industry and academia participated and shared their research and thoughts. The event mainly focused on intersection of blockchain knowledge and multimedia data science.",
    contentZH: (
      <p>
        <a
          href="https://mp.weixin.qq.com/s/uA2z4O6jC9FCBzrSaJArkg"
          target="_blank"
          rel="noreferrer"
        >
          2021年4月27日
        </a>
        ，BMDS2021在线研讨会顺利召开，该系列研讨会主要围绕区块链与数据科学领域进行研究与分享，主要针对区块链知识和多媒体数据科学的交叉融合，进行深度研讨，碰撞出思维的火花。
        <br />
        <a
          href="https://mp.weixin.qq.com/s/kbCJUROKpl7wfjSjUMXIiA"
          target="_blank"
          rel="noreferrer"
        >
          2021年4月28日
        </a>
        ，BMDS2021第二日在线研讨会按时举行，参会嘉宾有南京纯白矩阵科技有限公司总经理吴啸、香港中文大学（深圳）人云系统实验室主任蔡玮博士和阿尔伯塔大学的计算机科学教授Anup
        Basu博士。
        <br />
        <a
          href="https://mp.weixin.qq.com/s/_6j2S1uV1JCPi5Od0axkvg"
          target="_blank"
          rel="noreferrer"
        >
          2021年4月29日
        </a>
        ，BMDS2021第三日在线研讨会按时举行，参会嘉宾有Health
        Gauge 联合创始人Brunce
        Matichuk、不列颠哥伦比亚大学计算机与科学学院教授王泽华博士以及纯白矩阵技术科学家孙昕尧。
        <br />
        <a
          href="https://mp.weixin.qq.com/s/EOGieCYxcmEm5AMHTXMYgg"
          target="_blank"
          rel="noreferrer"
        >
          2021年4月30日
        </a>
        ，BMDS2021第四日在线研讨会按时举行，参会嘉宾有加拿大多伦多花旗银行副总裁Neha
        Raj、蚂蚁集团投资总监兼A&T资本管理合伙人于隽、BestBuy市场研发部的首席工程师Aaron
        Liu以及Nanopay的COO Carlos，共同探讨关于产业机会话题。
      </p>
    ),
    link: "https://matrixwhite-mgt.medium.com/whitematrix-successfully-conducted-bmds2021-blockchain-multimedia-data-science-seminar-227ce70a0b70",
  },
  {
    index: "03",
    date: "2021.03.08",
    title:
      "Successful Completion of 08 Weeks Training on Blockchain for African Students",
    titleZH: "纯白矩阵参与Masterclass，助力非洲开发者生态",
    content:
      "WhiteMatrix, Binance, XEND finance, and Bundle collaborated to train 1000 African developers with one of the most promising technologies for the future, blockchain. Experienced leaders presented the speech on different topics in blockchain from basic to advance. 19.9k developers registered for this event and took benefits from this training. Binance CEO Changpeng Zhao (CZ) also participated in the opening ceremony of this event. This training continued for 08 days and developers created amazing projects in the end, which proves their potential for blockchain.",
    contentZH: (
      <p>
        <a
          href="https://mp.weixin.qq.com/s/ekBnotO-Zy3h0FiL9DPkbQ"
          target="_blank"
          rel="noreferrer"
        >
          2021年1月31日
        </a>
        ，纯白矩阵CEO吴啸受邀参加African Binance
        Masterclass教育系列的开幕仪式。纯白矩阵将会与Binance Master和Binance
        Smart Chain团队共同为在非洲的1000名开发者们提供完整的免费培训。
        <br />
        <a
          href="https://mp.weixin.qq.com/s/UjSwxLRGcwm5wgzASe8QIg"
          target="_blank"
          rel="noreferrer"
        >
          2021年2月6日
        </a>
        ，纯白矩阵创始人吴啸为非洲开发者进行了以”Blockchain:Technology,
        Innovation and
        Thinking”为主题的讲座。这也是非洲Masterclass公开课的第一节课程。
        <br />
        <a
          href="https://mp.weixin.qq.com/s/bbTYkasgOFfbedEp8O7Bpg"
          target="_blank"
          rel="noreferrer"
        >
          2021年2月20日
        </a>
        ，纯白矩阵CTO张舒艺受邀参加第三周非洲Masterclass公开课，此次公开课以“Decentralized
        Application”为主题，为非洲开发者分享关于智能合约与EVM的内容。
        <br />
        <a
          href="https://mp.weixin.qq.com/s/uxKXOznxQuFpaONBQyTm1w"
          target="_blank"
          rel="noreferrer"
        >
          2021年3月8日
        </a>
        ，纯白矩阵生态负责人赵伊磊受邀参加非洲Masterclass公开课，此次公开课以”What’s
        Defi?How to build a Defi
        app?”为主题，介绍了关于Defi应用和生态当中的一些内容。
      </p>
    ),
    link: "https://matrixwhite-mgt.medium.com/whitematrix-supports-african-blockchain-technology-education-chainide-helps-african-developer-26b06def3bc0",
  },
]

export function News() {
  return (
    <section className={`${sectionStyle.section} ${newsStyle.news}`}>
      <h2 className={sectionStyle.sectionHeader}>NEWS</h2>
      <div>
        {newsList.map(news => {
          return <NewsItem key={news.index} news={news} />
        })}
      </div>
    </section>
  )
}
